// Build a URL-safe slug from a video title.
export const slugify = (s) => {
  if (!s) return "video";
  return s
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/€/g, "e")
    .replace(/['"`]+/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80) || "video";
};

// Build the human-readable share URL for a video.
// Pattern: {origin}/api/watch/{slug}_{shortid-8}
export const buildShareUrl = (video) => {
  if (!video) return window.location.origin;
  const shortId = String(video.id).replace(/-/g, "").slice(0, 8);
  const slug = slugify(video.title);
  return `${window.location.origin}/api/watch/${slug}_${shortId}`;
};
